module.exports = __webpack_public_path__ + "static/media/manitas.45282035.jpg";